<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import * as types from "./store/constant";
import { store } from "./store/store";
// import Vue from "vue";
// import Toast from "vue-toastification";
// import "vue-toastification/dist/index.css";

// Vue.use(Toast, {
//   transition: "Vue-Toastification__bounce",
//   maxToasts: 20,
//   newestOnTop: true
// });



export default {
  name: "app",
  created() {
    this.$http.interceptors.response.use(
      undefined,
      err =>
        new Promise(() => {
          if (Object.keys(err).length !== 0) {
            if (
              err.response.status === 401 &&
              err.config &&
              !err.config.__isRetryRequest
            ) {
              store.dispatch(types.AUTH_LOGOUT);
              if (window.location.pathname !== "/login") {
                document.location.href = "/login";
              }
            }
            throw err;
          }
          if (window.location.pathname !== "/login") {
            document.location.href = "/login";
          }
        })
    );
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Nunito&display=swap");

html {
  line-height: 1.15; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

body {
  margin: 0;
  font-family: "Nunito", sans-serif;
}

* {
  box-sizing: border-box;
  width: 100%;
}

a {
  text-decoration: none;
}

main {
  display: block;
}

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}

pre {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  text-decoration: underline dotted; /* 2 */
}

b,
strong {
  font-weight: bolder;
}

code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

small {
  font-size: 80%;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

img {
  border-style: none;
}

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}

button,
input {
  /* 1 */
  overflow: visible;
}

button,
select {
  /* 1 */
  text-transform: none;
}

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

fieldset {
  padding: 0.35em 0.75em 0.625em;
}

legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}

progress {
  vertical-align: baseline;
}

textarea {
  overflow: auto;
}

[type="checkbox"],
[type="radio"] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

details {
  display: block;
}

summary {
  display: list-item;
}

template {
  display: none;
}

[hidden] {
  display: none;
}

.admin__home {
  padding-top: 80px;
  min-width: 1000px;
  overflow: hidden;
}

.admin__home--left-div {
  background: #fff;
  width: 190px;
  height: 100%;
  padding-top: 26px;
  padding-bottom: 50px;
  position: fixed;
  left: 0;
  top: 80px;
  overflow: auto;
}

.admin__home--right-div {
  // float: left;
  width: 100%;
  min-height: 700px;
  padding-left: 190px;
  background: #fbfafa;
}

.admin__home--btn {
  font-size: 0.729vw;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: center;
  padding-top: 13px;
  margin: 0 auto 100px auto;
}

.admin__home--btn > a {
  color: #5099de;
}
</style>
